import { useTheme } from "@mui/material";
import { FolderPlus } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { usePinDrawerStep } from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/usePinDrawerStep";
import { NewFolderForm } from "web_myplann/Portfolio/Forms/NewFolderForm/NewFolderForm";
import { FlatRowSelectOptionList } from "web_myplann/Shared/Components/FlatRow/FlatRowSelectOptionList";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

const R = Resources.Portfolio.List.DocumentUpload.FolderPicker;

type Step = "list" | "new";

type Props = {
	open: boolean;
	onClose: () => void;
	folders: string[];
	selectedFolder: string | null;
	onSelect: (folder: string) => void;
};

export const FolderPickerDrawer: FC<Props> = ({
	open,
	onClose,
	folders,
	selectedFolder,
	onSelect,
}) => {
	const { palette, iconSize } = useTheme();
	const { t } = useResource();
	const hasFolders = folders.length > 0;
	const { step, setStep } = usePinDrawerStep<Step>(
		open,
		hasFolders ? "list" : "new",
	);

	return (
		<>
			<MyPlannDrawer
				open={open && step === "list"}
				grabber
				onClose={onClose}
				title={t(R.title)}
			>
				<FlatRowSelectOptionList
					options={folders.map((folder) => ({ value: folder, label: folder }))}
					value={selectedFolder ?? ""}
					onSelect={onSelect}
					bottomAction={{
						label: t(R.newFolder),
						icon: <FolderPlus size={iconSize.md} color={palette.orange[500]} />,
						color: palette.orange[600],
						onClick: () => setStep("new"),
					}}
				/>
			</MyPlannDrawer>

			<MyPlannDrawer
				open={open && step === "new"}
				onClose={hasFolders ? () => setStep("list") : onClose}
				title={t(R.newFolder)}
				grabber
			>
				<NewFolderForm
					label={t(R.newFolderLabel)}
					placeholder={t(R.newFolderPlaceholder)}
					submitLabel={t(R.createAndSelect)}
					onSubmit={onSelect}
				/>
			</MyPlannDrawer>
		</>
	);
};
